import { DeleteModal } from "@/components/modal/DeleteModal.tsx";
import type { DeleteFirewallMutation } from "@/modules/network/firewall/FirewallView.tsx";
import type { FirewallWithType } from "@/modules/network/firewall/firewallApi.ts";
import { Trans } from "@lingui/react/macro";

export function FirewallDeleteModal({
    item,
    deleteMutation,
}: {
    item: FirewallWithType;
    deleteMutation: DeleteFirewallMutation;
}) {
    const { location, uuid } = item;

    async function onDelete() {
        await deleteMutation.mutateAsync({ location, uuid });
    }

    return (
        <DeleteModal modalAction={async () => await onDelete()}>
            <Trans>
                This will delete the firewall and its associated rules, and they will no longer apply to any assigned
                resources.
            </Trans>
        </DeleteModal>
    );
}
